import * as React from 'react';
import { Redirect, useHistory, useParams } from 'react-router-dom';
import { Breadcrumb, Heading } from 'vet-bones/design-system/components';

import {
  PORTAL_ENDPOINT_BREADCRUMB_ENDPOINTS,
  PORTAL_ENDPOINT_HEADING,
} from 'src/ui/constants/testIds';
import { PortalEndpointUserTable } from 'src/ui/containers/endpoints/PortalEndpointUserTable';
import { graphQLClient } from 'src/ui/graph/graphQLClient';
import { useSavedConnectionsQuery } from 'src/ui/graph/types';
import { useProfile } from 'src/ui/hooks/connection';
import * as copy from 'src/ui/templates/copy';

export const PortalEndpoint: React.VFC = () => {
  const history = useHistory();
  const { id } = useParams<{ id: string }>();

  const { data: profile, isLoading: isLoadingProfile } = useProfile();
  const {
    data: connectionsData,
    isLoading: isLoadingConnections,
  } = useSavedConnectionsQuery(graphQLClient, {});

  const connection = React.useMemo(
    () =>
      connectionsData?.listConnections?.find(
        (conn) => conn?.index?.toString() === id
      ),
    [connectionsData, id]
  );

  const isOwner = React.useMemo(
    () =>
      connection?.organization?.owner &&
      profile?.profile &&
      connection.organization.owner.username === profile.profile.username,
    [connection, profile]
  );

  if (
    !isLoadingProfile &&
    !isLoadingConnections &&
    (!isOwner ||
      !connection ||
      !(connection.isStardogCloud || connection.isStardogFree))
  ) {
    return <Redirect to="/connections" />;
  }

  return (
    <div className="organization-dashboard">
      <div className="organization-dashboard-header">
        <div className="organization-dashboard-header-info">
          <Heading size="xl" testId={PORTAL_ENDPOINT_HEADING} weight="semibold">
            {copy.components.endpoints.dashboard.title}
          </Heading>
          <Breadcrumb
            items={[
              {
                id: 'endpoints',
                onClick: () => history.push('/connections'),
                testId: PORTAL_ENDPOINT_BREADCRUMB_ENDPOINTS,
                text: copy.components.endpoints.dashboard.breadcrumb.endpoints,
              },
              {
                id: 'endpoint',
                text: connection?.name || '',
              },
            ]}
          />
        </div>
      </div>

      <PortalEndpointUserTable />
    </div>
  );
};
